var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowdown = function SvgArrowdown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 10,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.34.873a1.174 1.174 0 0 1 1.616.01L8 6.778 14.044.883a1.174 1.174 0 0 1 1.616-.01c.45.427.454 1.123.01 1.556L8.814 9.117c-.214.21-.507.327-.813.327-.306 0-.599-.117-.813-.327L.33 2.43A1.072 1.072 0 0 1 .34.873Z",
    fill: "#333"
  })));
};
export default SvgArrowdown;